import sha256 from 'crypto-js/sha256';

import { LOGIN_USER_SUCCESS, LOGIN_USER_FAILED, LOGIN_USER, LOGOUT_USER, } from './types';

import post from "../../api/methods/post";
import { LOGIN_POST } from '../../api/authEndpoints';

import {fetchInProgressJourneys, fetchCompletedJourneys } from "./index";

export const logoutUser = () => {
    return {
        type: LOGOUT_USER
    };
};


export const loginUserAsync = (userId, password) => {
    return async (dispatch) => {
        dispatch({ type: LOGIN_USER });

        try {

            // TODO(Celso): Isso está demorando uma eternidade em produção, fazer com callback!
            // const pushIds = await getPushPermissions;

            const body = {
                userId: userId,
                password: sha256(password).toString(),
                // pushUserId: pushIds === null ? null : pushIds.userId
            };

            let authResponse = await post(LOGIN_POST, body);
            let authResponseJson = await authResponse.json();

            if (authResponse.status === 503) {
                dispatch({ type: LOGIN_USER_FAILED, payload: "Aplicativo está em manutenção!" });
                throw (authResponseJson);
            }

            // await dispatch(fetchJourneys());
            await dispatch(fetchInProgressJourneys(userId));
            await dispatch(fetchCompletedJourneys(userId));

            // const lastOpenJourneyId = authResponseJson.data.userData.journeyData.lastInProgressWatched;
            // if (stringIsEmpty(lastOpenJourneyId) === false) {
            //     //TODO(Celso): Podia ser requisitado apenas Título e Imagem da jornada, e não ela inteira!
            //     await dispatch(fetchJourneyAndUserProgress(lastOpenJourneyId, userId));
            // }

            dispatch({
                type: LOGIN_USER_SUCCESS,
                payload: {
                    userId: userId,
                    password: password,

                    sessionData: authResponseJson.data.sessionData,

                    personalData: authResponseJson.data.userData.personalData,
                    journeyData: authResponseJson.data.userData.journeyData,
                }
            })

            // loginUserSuccess(dispatch, email, password, authData, userData, aggregationData);

            return authResponseJson;

        } catch (e) {
            console.log('login error')
            console.log(e);
            dispatch({ type: LOGIN_USER_FAILED, payload: "Erro ao fazer login" });
            throw (e);
        }
    }
};
